import {
    Box,
    Button,
    Link,
    Stack,
    Typography,
} from '@mui/material'
import WithUs1 from '../../../assets/home/fn_withus1.png'
import WithUs2 from '../../../assets/home/fn_withus2.png'
import WithUs3 from '../../../assets/home/fn_withus3.png'
import NextLink from 'next/link'
import { Image } from 'antd'
import React from 'react'
import { App_Language_key, ROOT_PATH } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMHomeFinancingWithUs: React.FC = () => {

    const { t } = useTranslation()

    const imageList = [WithUs1, WithUs2, WithUs3]
    const titleList = [t('t31'), t('t32'), t('t33')]
    const contentList = [t('t34'),
        t('t35'),
        t('t36')]
    const linkList = ['/motorcycle-financing', '/personal-loan', '/motor-vehicle']

    // ======================= RENDER FUNCTIONS
    const renderPlan = (index: number) => {
        return (
            <Box
                key={index}
                width={405}
                flexDirection={'column'}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}
                paddingBottom={{ xs: 10, lg: 20 }}>

                <Box
                    width={'100%'}
                    position={'relative'}
                    sx={{
                        //background: 'linear-gradient(to bottom, #F9BE22, #FFFDF7)'
                    }}
                    alignContent={'center'}
                    borderRadius={10}
                >
                    <Image src={imageList[index]} alt='' preview={false}></Image>
                </Box>
                <Box position={'absolute'} paddingTop={'215px'}>
                    <Box
                        height={sessionStorage.getItem(App_Language_key) === 'ms' ? 350 : 330}
                        borderRadius={2}
                        paddingLeft={7.5}
                        paddingRight={7.5}
                        paddingBottom={4}
                        paddingTop={3}
                        //border="1px solid #E5E7EB"
                        bgcolor="white"
                        width={372}
                        sx={{ boxShadow: '0 0 10px 5px rgba(20, 31, 57, 0.06)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                    >
                        <Box>
                            <Typography fontSize={20} color={'#141F39'} textAlign={'left'} paddingTop={'20px'} fontWeight={500}>
                                {titleList[index]}
                            </Typography>

                            <Typography fontSize={16} color={'#6B6B6B'} width={'100%'} textAlign={'left'} paddingTop={'24px'} fontWeight={400}>
                                {contentList[index]}
                            </Typography>
                        </Box>

                        <Link component={NextLink} href={ROOT_PATH + linkList[index]}>
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    borderRadius: '30px',
                                    mt: 4,
                                    height: 61,
                                    fontSize: 16,
                                    fontWeight: 500,
                                    bgcolor: '#FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    textTransform: 'none',
                                }}
                            >
                                {t('t37')}
                            </Button>
                        </Link>
                    </Box>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            paddingBottom={{ xs: 10, lg: 20 }}
        >
            <Typography variant="h5" width={'100%'} textAlign={'center'} paddingTop={'72px'} paddingBottom={'45px'} fontWeight={700}>
                {t('t30')}
            </Typography>

            <Box
                maxWidth={1280}
                margin="auto"
            >
                <Stack
                    direction="row"
                    display={{
                        xs: 'none',
                        lg: 'flex',
                    }}
                    justifyContent="space-between"
                >
                    {imageList.map((item, index) => renderPlan(index))}
                </Stack>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeFinancingWithUs
